



































































































































































































import { Vue, Component } from 'vue-property-decorator';
import { CreateElement, VNode } from 'vue';
import { SwTabGroup, SwTabPage, TabProps, TabRenderData } from '@libs/unified-ui-framework/src/shared/sw-tab-layout';
import { SwBarProgress } from '@libs/unified-ui-framework/src/shared/sw-progress';
import { SwCountryIcon } from '@libs/unified-ui-framework/src/shared/sw-country-icon';
import { SwChartGaugeDonut, SwChartLine, SwChartCompareBar, CompareBarData, GaugeLollipopValue } from '@libs/unified-ui-framework/src/shared/sw-chart';
import { SwTitlePane } from '@libs/unified-ui-framework/src/shared/sw-title-pane';
import { SwIcon } from '@libs/unified-ui-framework/src/shared/sw-icon';
import { SwTextTab } from './components/sw-text-tab';
import { SwCustomLeftTab } from './components/sw-custom-left-tab';
import SwGeoMapCanvas from './components/sw-geo-map-canvas.vue';
import SwGeoMapSvg  from './components/sw-geo-map-svg.vue';
import { SwCanvasMap }  from './components/sw-canvas-map';
import { SwDonutConcentric } from './components/sw-donut-concentric';
import { SwTabPageComponent } from './components/sw-tab-page-component';
import { AttackOriginCountry, Region, TypeOfThreats, CustomTabProps, CustomTabRenderData, YearComparisonLineGraphData } from './types';
import { SwScrollView } from '@libs/unified-ui-framework/src/shared/sw-scroll-view';
import { ApiService } from '@libs/unified-ui-framework/src/shared/api-service';
import { SwBlockingProgress } from '@libs/unified-ui-framework/src/shared/sw-blocking-progress';
// import _ from 'lodash';
const cssPrefix = 'sw-ftr-capture-labs-threat-metrics';

@Component({
  components: {
    SwGeoMapSvg,
    SwGeoMapCanvas,
    SwTabGroup,
    SwTabPage,
    SwBarProgress,
    SwCountryIcon,
    SwChartLine,
    SwTitlePane,
    SwChartCompareBar,
    SwIcon,
    SwTextTab,
    SwCanvasMap,
    SwDonutConcentric,
    SwChartGaugeDonut,
    SwTabPageComponent,
    SwScrollView,
    SwBlockingProgress,
  },
})

export default class SwFtrCaptureLabsThreatMetrics extends Vue {
  cssPrefix = cssPrefix;
  selectedVerticalTabId: string = 'tab1';
  selectedVerticalTabId2: string = 'tab9';
  selectedRightTabLabel = 'WW';
  selectedLeftTabLabel = 'Malware';
  tabId: number = 1;
  labels = ['APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  waf = false;
  loading:boolean = true;
  barColorPalette: string[] = [
    '#47afe8',
    '#ffcc00',
    '#47afe8',
    '#ffcc00',
    '#47afe8',
    '#ffcc00',
    '#47afe8',
    '#ffcc00',
    '#47afe8',
    '#ffcc00',
  ];
  countryMap: {[id: string]: number} = {
    Unknown : 0,
    // Private IP : 1,
    // Satellite Provider : 2,
    Andorra : 3,
    'United Arab Emirates' : 4,
    Afghanistan : 5,
    'Antigua and Barbuda' : 6,
    Anguilla : 7,
    Albania : 8,
    Armenia : 9,
    'Netherlands Antilles' : 10,
    Angola : 11,
    // Asia/Pacific Region : 12,
    Antarctica : 13,
    Argentina : 14,
    'American Samoa' : 15,
    Austria : 16,
    Australia : 17,
    Aruba : 18,
    Aland : 19,
    Azerbaijan : 20,
    'Bosnia and Herzegovina' : 21,
    Barbados : 22,
    Bangladesh : 23,
    Belgium : 24,
    'Burkina Faso' : 25,
    Bulgaria : 26,
    Bahrain : 27,
    Burundi : 28,
    Benin : 29,
    Bermuda : 30,
    Brunei : 31,
    Bolivia : 32,
    Brazil : 33,
    Bahamas : 34,
    Bhutan : 35,
    // 'Bouvet Island' : 36,
    Botswana : 37,
    Belarus : 38,
    Belize : 39,
    Canada : 40,
    'Cocos Keeling Islands' : 41,
    'Democratic Republic of the Congo' : 42,
    'Central African Republic' : 43,
    'Republic of the Congo' : 44,
    Switzerland : 45,
    'Cote dIvoire' : 46,
    'Cook Islands' : 47,
    Chile : 48,
    Cameroon : 49,
    China : 50,
    Colombia : 51,
    'Costa Rica' : 52,
    Cuba : 53,
    'Cape Verde': 54,
    'Christmas Island' : 55,
    Cyprus : 56,
    'Czech Republic' : 57,
    Germany : 58,
    Djibouti : 59,
    Denmark : 60,
    Dominica : 61,
    'Dominican Republic' : 62,
    Algeria : 63,
    Ecuador : 64,
    Estonia : 65,
    Egypt : 66,
    'Western Sahara' : 67,
    Eritrea : 68,
    Spain : 69,
    Ethiopia : 70,
    'European Union' : 71,
    Finland : 72,
    Fiji : 73,
    'Falkland Islands' : 74,
    Micronesia : 75,
    Faroes : 76,
    France : 77,
    Gabon : 78,
    'United Kingdom' : 79,
    Grenada : 80,
    Georgia : 81,
    'French Guiana' : 82,
    Guernsey : 83,
    Ghana : 84,
    Gibraltar : 85,
    Greenland : 86,
    Gambia : 87,
    Guinea : 88,
    // Guadeloupe : 89,
    'Equatorial Guinea' : 90,
    Greece : 91,
    'South Georgia and the South Sandwich Islands' : 92,
    Guatemala : 93,
    Guam : 94,
    'Guinea Bissau' : 95,
    Guyana : 96,
    'Hong Kong' : 97,
    // 'Heard Island and McDonald Island' : 98,
    Honduras : 99,
    Croatia : 100,
    Haiti : 101,
    Hungary : 102,
    Indonesia : 103,
    Ireland : 104,
    Israel : 105,
    'Isle of Man' : 106,
    India : 107,
    // 'British Indian Ocean Territory' : 108,
    Iraq : 109,
    Iran : 110,
    Iceland : 111,
    Italy : 112,
    Jersey : 113,
    Jamaica : 114,
    Jordan : 115,
    Japan : 116,
    Kenya : 117,
    Kyrgyzstan : 118,
    Cambodia : 119,
    Kiribati : 120,
    Comoros : 121,
    'Saint Kitts and Nevis' : 122,
    'North Korea' : 123,
    'Republic of Korea' : 124,
    Kuwait : 125,
    'Cayman Islands' : 126,
    Kazakhstan : 127,
    Laos : 128,
    Lebanon : 129,
    'Saint Lucia' : 130,
    Liechtenstein : 131,
    'Sri Lanka' : 132,
    Liberia : 133,
    Lesotho : 134,
    Lithuania : 135,
    Luxembourg : 136,
    Latvia : 137,
    Libya : 138,
    Morocco : 139,
    Monaco : 140,
    Moldova : 141,
    Montenegro : 142,
    Madagascar : 143,
    'Marshall Islands' : 144,
    Macedonia : 145,
    Mali : 146,
    Myanmar : 147,
    Mongolia : 148,
    Macau : 149,
    'Northern Mariana Islands' : 150,
    Martinique : 151,
    Mauritania : 152,
    Montserrat : 153,
    Malta : 154,
    Mauritius : 155,
    Maldives : 156,
    Malawi : 157,
    Mexico : 158,
    Malaysia : 159,
    Mozambique : 160,
    Namibia : 161,
    'New Caledonia' : 162,
    Niger : 163,
    'Norfolk Island' : 164,
    Nigeria : 165,
    Nicaragua : 166,
    Netherlands : 167,
    Norway : 168,
    Nepal : 169,
    Nauru : 170,
    Niue : 171,
    'New Zealand' : 172,
    // 'Other Country' : 173,
    Oman : 174,
    Panama : 175,
    Peru : 176,
    'French Polynesia' : 177,
    'Papua New Guinea' : 178,
    Philippines : 179,
    Pakistan : 180,
    Poland : 181,
    // 'Saint Pierre and Miquelon' : 182,
    // unknown : 183,
    'Puerto Rico' : 184,
    Palestine : 185,
    Portugal : 186,
    Palau : 187,
    Paraguay : 188,
    Qatar : 189,
    Reunion : 190,
    Romania : 191,
    Serbia : 192,
    Russia : 193,
    Rwanda : 194,
    'Saudi Arabia' : 195,
    'Solomon Islands' : 196,
    Seychelles : 197,
    Sudan : 198,
    Sweden : 199,
    Singapore : 200,
    'Saint Helena' : 201,
    Slovenia : 202,
    // 'Svalbard and Jan Mayen' : 203,
    Slovakia : 204,
    'Sierra Leone' : 205,
    'San Marino' : 206,
    Senegal : 207,
    Somalia : 208,
    Suriname : 209,
    'Sao Tome and Principe' : 210,
    'El Salvador' : 211,
    Syria : 212,
    Swaziland : 213,
    'Turks and Caicos Islands' : 214,
    Chad : 215,
    'French Southern Territories' : 216,
    Togo : 217,
    Thailand : 218,
    Tajikistan : 219,
    Tokelau : 220,
    // unknown : 221,
    Turkmenistan : 222,
    Tunisia : 223,
    Tonga : 224,
    Turkey : 225,
    'Trinidad and Tobago' : 226,
    Tuvalu : 227,
    Taiwan : 228,
    Tanzania : 229,
    Ukraine : 230,
    Uganda : 231,
    // 'United States Minor Outlying Is' : 232,
    'United States' : 233,
    Uruguay : 234,
    Uzbekistan : 235,
    'Vatican City' : 236,
    'Saint Vincent and the Grenadines' : 237,
    Venezuela : 238,
    'British Virgin Islands' : 239,
    'US Virgin Islands' : 240,
    Vietnam : 241,
    Vanuatu : 242,
    'Wallis And Futuna' : 243,
    Samoa : 244,
    Yemen : 245,
    Mayotte : 246,
    'South Africa' : 247,
    Zambia : 248,
    Zimbabwe : 249,
    'Saint Martin' : 250,
    'Pitcairn Islands' : 251,
    // 'Timor Leste' : 252,
    Curacao : 253,
    // 'Saint Martin' : 254,
    // 'Bonaire Saint Eustatius and Sa' : 255,
  };

  dataSet = [{}];
  dataSet1 = [{}];
  dataYear: Chart.ChartDataSets[] = [];
  dataPrev: Chart.ChartDataSets[] = [];
  country: AttackOriginCountry[] = [];
  label: string = '';
  defaultDataset = [{ backgroundColor: 'transparent' }];
  dataSetConc: GaugeLollipopValue[] = [
    { value: 0 },
    { value: 0 },
    { value: 0 },
    { value: 0 },
  ];
  gaugeLabels: string[] = [];
  countryDataSet = [{}];
  gauge: number[] = [NaN, NaN];
  cmpBarData: CompareBarData = {
    categoryLabels: [],
    dataset: [],
  };
  threats: TypeOfThreats[];
  actualData: Chart.ChartDataSets[] = [];
  actualData1 = [];
  wwactualData: Chart.ChartDataSets[] = [];
  top4Origins = [];
  top4OriginsData = [];
  regionName: string = 'World Wide';
  rotate: number = 0;
  wwvalue: string | number = 0;
  wwrotate: number = 0;
  previous: number = 340;
  present: number = 360;
  convertAll = '';
  prevWWData = {};
  date = new Date();
  dateYear = this.date.getFullYear()
  .toString()
  .slice(-2);
  dateMonth = (`0${this.date.getMonth()}`)
  .slice(-2);
  dateFromYear = `0${(this.date.getFullYear() - 1)}`
  .slice(-2);
  to = '';
  from = '';
  toDate = '';
  fromDate = '';
  doesNotHaveData = false;
  diffMonth = 0;
  previousTabMappings: { [key: string]: number} = {
    tab1 : 330,
    tab2 : 116,
    tab3 : 0.008,
    tab4 : 560,
    tab5 : 329,
    tab6 : 25,
    tab7 : 448,
    tab8 : 0.42,
    tab13 : 2.66,
    tab14 : 2.66,
    tab15 : 2.66,
    tab16 : 2.66,
  };
  presentTabMappings: { [key: string]: number} = {
    tab1 : 437,
    tab2 : 185,
    tab3 : 0.012,
    tab4 : 346,
    tab5 : 256,
    tab6 : 14,
    tab7 : 654,
    tab8 : 0.33,
    tab13 : 2.07,
    tab14 : 2.07,
    tab15 : 2.07,
    tab16 : 2.66,
  };
  leftPercentages: { [key: string]: string | number} = {
    tab1 : 0,
    tab2 : 0,
    tab3 : 0,
    tab4 : 0,
    tab5 : 0,
    tab6 : 0,
    tab7 : 0,
    tab8 : 0,
    tab13 : 0,
    tab14 : 0,
    tab15 : 0,
    tab16 : 2.66,
  };
  rotateTabMappings: { [key: string]: number} = {
    tab1 : 0,
    tab2 : 0,
    tab3 : 0,
    tab4 : 180,
    tab5 : 180,
    tab6 : 180,
    tab7 : 0,
    tab8 : 180,
    tab13 : 180,
    tab14 : 180,
    tab15 : 180,
    tab16 : 2.66,
  };
  compareBarConfig = {};
  continents : { [key: string]: string} = {
    WW : 'WW',
    NAM : 'NorthAmerica',
    EUR : 'Europe',
    APJ : 'Asia',
  };
  rNames: { [key: string]: string} = {
    WW : 'World Wide',
    NAM : 'North America',
    EUR : 'Europe',
    APJ : 'Asia Pacific',
  };
  threatTypes: { [key: string]: string} = {
    Malware : 'tab1',
    Intrusions : 'tab2',
    Ransomware : 'tab3',
    'Encrypted Traffic' : 'tab4',
    'Malware using HTTPS' : 'tab5',
    'New Threats - Capture' : 'tab6',
    'Spam Volume' : 'tab7',
    'Phishing Volume' : 'tab8',
    'Web App Attacks': 'tab13',
    Cryptojacking: 'tab14',
    'Malware on non-std ports': 'tab15',
    'IoT Malware': 'tab16',
  };
  monthsFromData: string[] = [];
  datesMonth: {[key: string]: string} = {
    '01': 'JAN', '02': 'FEB', '03': 'MAR', '04': 'APR', '05': 'MAY', '06': 'JUN', '07': 'JUL', '08': 'AUG', '09': 'SEP', 10: 'OCT',
    11: 'NOV', 12: 'DEC',
  };

  verticalTabsProps: CustomTabProps[] = [
    { tabId: 'tab1', label: 'Malware', rotate: this.rotate, previous: this.previous, present : this.present, innerRender: this.customizedTabRender },
    { tabId: 'tab2', label: 'Intrusions', rotate: this.rotate, previous: this.previous, present : this.present, innerRender: this.customizedTabRender },
    { tabId: 'tab3', label: 'Ransomware', rotate: this.rotate, previous: this.previous, present : this.present, innerRender: this.customizedTabRender },
    { tabId: 'tab4', label: 'Encrypted Traffic', rotate: this.rotate, previous: this.previous,
      present : this.present, innerRender: this.customizedTabRender },
    { tabId: 'tab5', label: 'Malware using HTTPS', rotate: this.rotate, previous: this.previous,
      present : this.present, innerRender: this.customizedTabRender },
    { tabId: 'tab6', label: 'New Threats - Capture', rotate: this.rotate, previous: this.previous,
      present : this.present, innerRender: this.customizedTabRender },
    { tabId: 'tab7', label: 'Spam Volume', rotate: this.rotate, previous: this.previous, present : this.present, innerRender: this.customizedTabRender },
    { tabId: 'tab8', label: 'Phishing Volume', rotate: this.rotate, previous: this.previous, present : this.present, innerRender: this.customizedTabRender },
    // { tabId: 'tab13', label: 'Web App Attacks',rotate: this.rotate,previous: this.previous, present: this.present,innerRender: this.customizedTabRender },
    { tabId: 'tab14', label: 'Cryptojacking', rotate: this.rotate, previous: this.previous, present : this.present, innerRender: this.customizedTabRender },
    { tabId: 'tab15', label: 'Malware on non-std ports', rotate: this.rotate, previous: this.previous, present : this.present, innerRender: this
    .customizedTabRender },
    { tabId: 'tab16', label: 'IoT Malware', rotate: this.rotate, previous: this.previous, present : this.present, innerRender: this
    .customizedTabRender },
  ];

  verticalTabsPropsRight: TabProps[] = [
    { tabId: 'tab9', label: 'WW', innerRender: this.customizedTabRender2 },
    { tabId: 'tab10', label: 'NAM', innerRender: this.customizedTabRender2 },
    { tabId: 'tab11', label: 'EUR', innerRender: this.customizedTabRender2 },
    { tabId: 'tab12', label: 'APJ', innerRender: this.customizedTabRender2 },
  ];

  verticalTabsPropsRightWW: TabProps[] = [
    { tabId: 'tab9', label: 'WW', innerRender: this.customizedTabRender2 },
  ];

  customizedTabRender(h: CreateElement, data: CustomTabRenderData): VNode {// tslint:disable-line
    return (
      <div style={{ width: '100%' }} class={['sw-flexbox']}>
        <SwCustomLeftTab
        {...{
          props: {
            mode: 'page',
            rotate: this.rotateTabMappings[data.props.tabId],
            text: data.props.label,
            selected: data.active,
            previous: this.previousTabMappings !== null ? this.previousTabMappings[data.props.tabId] : null,
            present: this.presentTabMappings !== null ? this.presentTabMappings[data.props.tabId] : null,
            percentage: this.leftPercentages[data.props.tabId],
          },
        }}
      ></SwCustomLeftTab>
      </div>
    ) as VNode;
  }

  customizedTabRender2(h: CreateElement, data: TabRenderData): VNode {// tslint:disable-line
    return (
      <div style={{ minWidth: '85px' }} class={['sw-flexbox', 'sw-flexbox--center-justify']}>
      <SwTextTab
        {...{
          props: {
            mode: 'page',
            text: data.props.label,
            selected: data.active,
          },
        }}
      ></SwTextTab>
      </div>
    ) as VNode;
  }

  onSelectTab(tabId: string) {
    this.convertAll = '';
    this.selectedVerticalTabId = tabId;
    this.selectedVerticalTabId2 = 'tab9';
    for (const list in this.verticalTabsProps) {
      if (this.verticalTabsProps[list].tabId === this.selectedVerticalTabId) {
        this.selectedLeftTabLabel = this.verticalTabsProps[list].label as string;
      }
    }
    for (const list in this.verticalTabsPropsRight) {
      if (this.verticalTabsPropsRight[list].tabId === this.selectedVerticalTabId2) {
        this.selectedRightTabLabel = this.verticalTabsPropsRight[list].label as string;
      }
    }
    if (this.selectedVerticalTabId2 === 'tab9') {
      this.wwvalue = 0;
      this.regionName = 'World Wide';
    }
    if (this.selectedVerticalTabId === 'tab13' || this.selectedVerticalTabId === 'tab14') {
      this.waf = true;
    } else {
      this.waf = false;
    }
    this.regionName = this.rNames[this.selectedRightTabLabel];
    this.changeTabId();
    this.dataSet = [{}];
    this.dataSet1 = [{}];
    this.countryDataSet = [{}];
    this.cmpBarData = {
      categoryLabels: [],
      dataset: [],
    };
    this.diffMonth = 0;
    this.processApi();
    // this.getData();
  }

  onSelectTab2(tabId: string) {
    this.selectedVerticalTabId2 = tabId;
    if (this.selectedVerticalTabId2 === 'tab9') {
      this.wwvalue = 0;
      this.regionName = 'World Wide';
    }
    for (const list in this.verticalTabsPropsRight) {
      if (this.verticalTabsPropsRight[list].tabId === this.selectedVerticalTabId2) {
        this.selectedRightTabLabel = this.verticalTabsPropsRight[list].label as string;
      }
    }
    this.regionName = this.rNames[this.selectedRightTabLabel];
    this.changeTabId();
    this.dataSet = [{}];
    this.dataSet1 = [{}];
    this.countryDataSet = [{}];
    this.cmpBarData = {
      categoryLabels: [],
      dataset: [],
    };
    this.diffMonth = 0;
    this.processApi();
    // this.getData();
  }

  changeTabId() {
    if (this.selectedVerticalTabId === 'tab1' || this.selectedVerticalTabId === 'tab2' || this.selectedVerticalTabId === 'tab3' ||
    this.selectedVerticalTabId === 'tab5' || this.selectedVerticalTabId === 'tab13' || this.selectedVerticalTabId === 'tab14' ||
     this.selectedVerticalTabId === 'tab15' || this.selectedVerticalTabId === 'tab16') {
      if (this.selectedVerticalTabId2 === 'tab9') {
        this.tabId = 1;
      } else {
        this.tabId = 2;
      }
    } else if (this.selectedVerticalTabId === 'tab4') {
      this.tabId = 3;
    } else if (this.selectedVerticalTabId === 'tab6') {
      this.tabId  = 4;  // Chart line only
    } else if (this.selectedVerticalTabId === 'tab7' || this.selectedVerticalTabId === 'tab8') {
      this.tabId = 5;
    } else if (this.selectedVerticalTabId === 'tab13' || this.selectedVerticalTabId === 'tab14') {
      this.tabId = 6;
      this.waf = true;
    }
  }

  isThreatSelected(it: TypeOfThreats) {
    if (it.threatName === this.selectedLeftTabLabel) {
      return it.regions;
    }
  }

  isThreatAttribute(it: Region) {
    if (it.regionCode === this.selectedRightTabLabel) {
      return it.attributes;
    }
  }

  getWWRegion(it: Region) {
    if (it.regionCode === 'WW') {
      return it.attributes;
    }
  }

  getData() {
    this.dataPrev = [];
    this.dataYear = [];
    // this.convertAll = '';
    /* this.to = `${this.datesMonth[this.dateMonth]}\'${this.dateYear}`;
    this.from = `${this.datesMonth[this.dateMonth]}\'${this.dateFromYear}`;
    this.toDate = `${this.datesMonth[this.dateMonth]} \'${this.dateYear}`;
    this.fromDate = `${this.datesMonth[this.dateMonth]} \'${this.dateFromYear}`; */
    if (this.date.getDate() <= 3) {
      if (this.date.getMonth() < 1) {
        this.dateMonth = '12';
        this.dateYear = (`0${(this.date.getFullYear() - 1)}`).slice(-2);
        /* this.to = `${this.datesMonth[this.dateMonth]}\'${this.dateYear}`;
        this.from = `${this.datesMonth[this.dateMonth]}\'${(`0${(this.date.getFullYear() - 2)}`).slice(-2)}`; */
      } else {
        this.dateMonth = (`0${(this.date.getMonth() - 1)}`).slice(-2);
        /* this.to = this.dateYear + this.dateMonth;
        this.from = `${this.datesMonth[this.dateMonth]}\'${(`0${(this.date.getFullYear() - 1)}`).slice(-2)}`; */
      }
    }
    for (let i = 0; i < 12; i = i + 1) {
      this.dataPrev.push(this.actualData[i]);
    }
    for (let i = 12; i < this.actualData.length; i = i + 1) {
      this.dataYear.push(this.actualData[i]);
    }
    if (this.selectedRightTabLabel === 'WW') {
      this.getHighestType(this.dataPrev, 0);
      this.getHighestType(this.dataYear, 1);
    }

    this.dataSet = [{ data: this.convertData(this.dataPrev, 0),
      label: this.convertAll, backgroundColor: 'transparent', borderColor: this.barColorPalette[0],
      spanGaps: true },
    { data: this.convertData(this.dataYear, 1),
      label: this.convertAll, backgroundColor: 'transparent', borderColor: this.barColorPalette[1],
      spanGaps: true }];
    const temp = [];
    if (!isNaN(Number(this.dataPrev[this.dataYear.length - 1]))) {
      temp.push(Number(this.dataPrev[this.dataYear.length - 1]));
    }
    if (!isNaN(Number(this.dataYear[this.dataYear.length - 1]))) {
      temp.push(Number(this.dataYear[this.dataYear.length - 1]));
    }
    this.changeToWWValues(true);
    if (this.selectedRightTabLabel === 'WW') {
      this.prevWWData = { data: this.dataPrev,
        label: this.convertAll, backgroundColor: 'transparent', borderColor: this.barColorPalette[2],
        spanGaps: true };
      if (this.doesNotHaveData) {
        this.cmpBarData = {
          categoryLabels: [this.to],
          dataset: [{
            data: temp,
            label: `WW[${this.convertAll.toString()
              .substr(0, this.convertAll.toString().length - 1)}]`,
          }],
        };
      } else {
        this.cmpBarData = {
          categoryLabels: [this.from, this.to],
          dataset: [{
            data: temp,
            label: `WW[${this.convertAll.toString()
              .substr(0, this.convertAll.toString().length - 1)}]`,
          }],
        };
      }
      // this.regionName = 'WorldWide';
      this.previous = temp[0];
      this.present = temp[1];
      this.rotate = (this.present - this.previous) > 0 ? 0 : 180;
      this.leftPercentages[this.selectedVerticalTabId] = ((Math.round(((this.present - this.previous) / this.previous) * 100)) > -1 &&
       (Math.round(((this.present - this.previous) / this.previous) * 100)) < 1) ? Number(((this.present - this.previous) / this.previous) * 100)
       .toFixed(1) : Math.round(((this.present - this.previous) / this.previous) * 100);
      this.wwvalue = ((Math.round(((this.present - this.previous) / this.previous) * 100)) > -1 &&
       (Math.round(((this.present - this.previous) / this.previous) * 100)) < 1) ?
       Number(((this.present - this.previous) / this.previous) * 100)
       .toFixed(1) :
        Math.round(((this.present - this.previous) / this.previous) * 100);
      this.wwrotate = (this.present - this.previous) > 0 ? 0 : 180;
      this.previousTabMappings[this.selectedVerticalTabId] = temp[0];
      this.presentTabMappings[this.selectedVerticalTabId] = temp[1];
      this.rotateTabMappings[this.selectedVerticalTabId] = (temp[1] - temp[0]) > 0 ? 0 : 180;
    } else {
      if (this.doesNotHaveData) {
        this.cmpBarData = {
          categoryLabels: [this.to],
          dataset: [{
            data: temp,
            label: this.selectedRightTabLabel === 'WW' ? `[${this.convertAll.toString()
              .substr(0, this.convertAll.toString().length - 1)}]` : '',
          }],
        };
      } else {
        this.cmpBarData = {
          categoryLabels: [this.from, this.to],
          dataset: [{
            data: temp,
            label: this.selectedRightTabLabel === 'WW' ? `[${this.convertAll.toString()
              .substr(0, this.convertAll.toString().length - 1)}]` : '',
          }],
        };
      }
      this.previous = temp[0];
      this.present = temp[1];
      this.rotate = (this.present - this.previous) > 0 ? 0 : 180;
      this.leftPercentages[this.selectedVerticalTabId] = ((Math.round(((this.present - this.previous) / this.previous) * 100)) > -1 &&
       (Math.round(((this.present - this.previous) / this.previous) * 100)) < 1) ? Number(((this.present - this.previous) / this.previous) * 100)
       .toFixed(1) : Math.round(((this.present - this.previous) / this.previous) * 100);
      this.previousTabMappings[this.selectedVerticalTabId] = temp[0];
      this.presentTabMappings[this.selectedVerticalTabId] = temp[1];
      this.rotateTabMappings[this.selectedVerticalTabId] = (temp[1] - temp[0]) > 0 ? 0 : 180;
    }
    if (this.selectedRightTabLabel !== 'WW') {
      this.dataPrev = [];
      this.dataYear = [];
      for (let i = 0; i < 12; i = i + 1) {
        this.dataPrev.push(this.wwactualData[i]);
      }
      for (let i = 12; i < this.wwactualData.length; i = i + 1) {
        this.dataYear.push(this.wwactualData[i]);
      }
      this.convertData(this.dataPrev, 0);
      this.convertData(this.dataYear, 1);
      const temp1 = [];
      if (!isNaN(Number(this.dataPrev[this.dataYear.length - 1]))) {
        temp1.push(Number(this.dataPrev[this.dataYear.length - 1]));
      }
      if (!isNaN(Number(this.dataYear[this.dataYear.length - 1]))) {
        temp1.push(Number(this.dataYear[this.dataYear.length - 1]));
      }
      this.cmpBarData.dataset.push({
        data: temp1,
        label: `WW[${this.convertAll.toString()
          .substr(0, this.convertAll.toString().length - 1)}]`,
      });
      this.dataSet.push(this.prevWWData);
    }
    for (const f of this.dataSet) {
      this.convertToTypes(f);
    }
    for (const f of this.cmpBarData.dataset) {
      this.convertToTypes(f);
    }
    this.compareBarConfig = {
      xAxes: [{
        gridLines: {
          color: '#000000',
          display: false,
          drawBorder: false,
          drawOnChartArea: false,
        },
        ticks: {
          display: true,
          suggestedMin: 0,
        },
      }],
      yAxes: [{
        gridLines: {
          color: '#000000',
          drawBorder: false,
          display: false,
          drawOnChartArea: false,
        },
        ticks: {
          display: false,
          min: 0,
          max: (this.tabId === 1 || this.tabId === 5 || this.tabId === 3) && this.cmpBarData.dataset[0] ?
                Math.max(...this.cmpBarData.dataset[0].data) * 1.05 :
                (this.cmpBarData.dataset[0] && this.cmpBarData.dataset[1] ?
                Math.max(...this.cmpBarData.dataset[0].data, ...this.cmpBarData.dataset[1].data) * 1.02 : 20),

          // (this.tabId === 1 || this.tabId === 5 || this.tabId === 3) && this.cmpBarData.dataset[0] ?
          //       Math.max(...this.cmpBarData.dataset[0].data) + (Math.max(...this.cmpBarData.dataset[0].data) < 100 ?
          //        (Math.max(...this.cmpBarData.dataset[0].data) < 2 ? 0.04 : (Math.max(...this.cmpBarData.dataset[0].data) < 20 ? 0.4 : 1.7)) : 25) :
          //       (this.cmpBarData.dataset[0] && this.cmpBarData.dataset[1] ?
          //       Math.max(...this.cmpBarData.dataset[0].data, ...this.cmpBarData.dataset[1].data) +
          //       (Math.max(...this.cmpBarData.dataset[0].data, ...this.cmpBarData.dataset[1].data) < 100 ?
          //         (Math.max(...this.cmpBarData.dataset[0].data, ...this.cmpBarData.dataset[1].data) < 2 ? 0.02 :
          //          (Math.max(...this.cmpBarData.dataset[0].data, ...this.cmpBarData.dataset[1].data) < 20 ? 0.2 : 1.5)) : 25) : 20),
        },
      }],
    };
  }

  convertToTypes(data: Chart.ChartDataSets) {
    const dataset:number[] = [];
    if (data.data) {
      for (const val of data.data) {
        dataset.push(Number(Number(val)
        .toFixed(2)));
      }
    }
    data.data = dataset;
  }

  getHighestType(ds: Chart.ChartDataSets[], index: number) {
    if (index === 0) {
      this.convertAll = '';
    }
    for (const val of ds) {
      if (this.convertAll === '' && Math.abs(Number(val)) >= 1000000000000) {
        this.convertAll = 'trillions';
      } else if (this.convertAll === '' && Math.abs(Number(val)) >= 1000000000) {
        this.convertAll = 'billions';
      } else if ((this.convertAll === '' && Math.abs(Number(val)) >= 1000000)
       || (this.convertAll === '' && Math.abs(Number(val)) >= 1000 && this.tabId !== 4)) {
        this.convertAll = 'millions';
      } else if (this.convertAll === '' && Math.abs(Number(val)) >= 1000) {
        this.convertAll = 'thousands';
      }
    }
  }

  convertData(ds: Chart.ChartDataSets[], index: number) {
    const dataset: number[] = [];
    let num: number;
    // if (index === 0) {
    //   this.convertAll = '';
    // }
    // if (!ds.label && ds.data) {
    for (const val of ds) {
      if ((index !== 0 && this.convertAll === 'trillions') || (this.convertAll === 'trillions')
      || (this.convertAll === '' && Math.abs(Number(val)) >= 1000000000000)
      ) {
        // console.log(val);
        if (Number(val) !== 0) {
          num = Math.abs(Number(val)) / 1000000000000;
          dataset.push(Number(num)); // + 'B'
          // console.log(Number(num));
        } else if (Number(val) === 0) {
          dataset.push(NaN);
        }
        this.convertAll = 'trillions';
      } else if ((index !== 0 && this.convertAll === 'billions') || (this.convertAll === 'billions')
      || (this.convertAll === '' && Math.abs(Number(val)) >= 1000000000)
      ) {
        // console.log(val);
        if (Number(val) !== 0) {
          num = Math.abs(Number(val)) / 1000000000;
          dataset.push(Number(num)); // + 'B'
          // console.log(Number(num));
        } else if (Number(val) === 0) {
          dataset.push(NaN);
        }
        this.convertAll = 'billions';
      } else if ((index !== 0 && this.convertAll === 'millions') || (this.convertAll === 'millions')
      || (this.convertAll === '' && Math.abs(Number(val)) >= 1000000)
       || (this.convertAll === '' && Math.abs(Number(val)) >= 1000 && this.tabId  !== 4)) {
        // console.log(val);
        if (Number(val) !== 0) {
          num = Math.abs(Number(val)) / 1000000;
          dataset.push(Number(num)); // + 'B'
          // console.log(Number(num));
        } else if (Number(val) === 0) {
          dataset.push(NaN);
        }
        this.convertAll = 'millions';
      } else if ((index !== 0 && this.convertAll === 'thousands') || (this.convertAll === 'thousands')
      || (this.convertAll === '' && Math.abs(Number(val)) >= 1000)
        ) {
        // console.log(val);
        if (Number(val) !== 0) {
          num = Math.abs(Number(val)) / 1000;
          dataset.push(Number(num)); // + 'B'
          // console.log(Number(num));
        } else if (Number(val) === 0) {
          dataset.push(NaN);
        }
        this.convertAll = 'thousands';
      } else if (this.label === 'percentage') {
        if (Number(val) !== 0) {
          dataset.push(Math.abs(Number(val)));
        } else if (Number(val) === 0) {
          dataset.push(NaN);
        }
        this.convertAll = 'percentage';
      } else {
        // console.log('Ones', val);
        if (Number(val) !== 0) {
          dataset.push(Math.abs(Number(val)));
        } else if (Number(val) === 0) {
          dataset.push(NaN);
        }
      }
    }
    if (index === 0) {
      this.dataPrev = dataset as Chart.ChartDataSets[];
    } else if (index === 1) {
      this.dataYear = dataset as Chart.ChartDataSets[];
    }
    // ds =
    // ds.label = this.convertAll;
    // }
    return dataset;
  }

  getWWData(data: YearComparisonLineGraphData[], rName: string) {
    const regions = this.threats.filter(this.isThreatSelected)[0].regions;
    const atts = regions.filter(this.getWWRegion)[0].attributes;
    let length: number = 0;
    const compareData: number[] = [];
    const categoryLabels : string[] = [];
    const temp: number[] = [];
    for (const i of atts) {
      if (i.hasOwnProperty('line')) {
        // return this.makeCompareBarData(i.line ? i.line : [], regions.filter(this.getWWRegion)[0].regionName);
        if (data[0].data.length < data[1].data.length) {
          length = data[0].data.length;
        } else if (data[0].data.length > data[1].data.length) {
          length = data[1].data.length;
        } else {
          length = data[0].data.length;
        }
        for (const d of data) {
          compareData.push(d.data[length - 1]);
          categoryLabels.push(`${this.labels[length - 1]}\'${d.year.toString()
          .substr(2, 2)}`);
        }
        if (rName === 'WorldWide') {
          this.regionName = 'WorldWide';
          this.previous = compareData[0];
          this.present = compareData[1];
          this.rotate = (this.present - this.previous) > 0 ? 0 : 180;
          return compareData;
        }
        return temp;
      }
    }
  }

  calculatePercentages() {
    for (const key of this.verticalTabsProps) {
      let length: number = 0;
      let lineCount: number = 0;
      const regions = this.threats.filter((it) => {
        if (it.threatName === key.label) {
          return it.regions;
        }
      })[0].regions;
      const atts = regions.filter((it) => {
        if (it.regionCode === 'WW') {
          return it.attributes;
        }
      })[0].attributes;
      for (const i of atts) {
        if (i.hasOwnProperty('line')) {
          if (i.line && lineCount === 0) {
            const compareData: number[] = [];
            const data: YearComparisonLineGraphData[] = i.line;
            if (data[0].data.length < data[1].data.length) {
              length = data[0].data.length;
            } else if (data[0].data.length > data[1].data.length) {
              length = data[1].data.length;
            } else {
              length = data[0].data.length;
            }
            for (const d of data) {
              compareData.push(d.data[length - 1]);
            }
            const tId:string = key.tabId;
            this.previousTabMappings[tId] = compareData[0];
            this.presentTabMappings[tId] = compareData[1];
            this.rotateTabMappings[tId] = (compareData[1] - compareData[0]) > 0 ? 0 : 180;
            lineCount = lineCount + 1;
          }
        }
      }
    }
  }

  get locationApStatusGauge(): GaugeLollipopValue[] {
    return [
      { value: 0 },
      { value: 3 },
      { value: 2 },
      { value: 0 },
    ];
  }

  processApi() {
    this.loading = true;
    const labelToQuery = this.selectedLeftTabLabel.replace(/[^A-Z0-9]/ig, '') === 'EncryptedTraffic' ? 'https' :
    this.selectedLeftTabLabel.replace(/[^A-Z0-9]/ig, '');
    // this.dataSetConc = [{ data: [0, 100], label: 'Connections1', backgroundColor: 'transparent' },
    //   { data: [0, 100], label: 'Connections2', backgroundColor: 'transparent' }];
    const rightLabel = this.selectedRightTabLabel;
    this.label = '';
    const apiService = new ApiService('');
    // // const username = 'csc_user';
    // // const password = 'N0$F3ar@S';
    // // const refresh = true;

    // const mysonicwallAPICall = apiService.get<any>('/api/Ransomware');

    // Promise.all([mysonicwallAPICall])
    // .then((_) => {
    //   store.commit('setMalware', { Malware: _ });

    //   console.log(_);
    //   // if (_[2] && _[2].msw && _[2].msw.error && _[2].msw.error === true) {
    //   //   this.error = true;
    //   // } else {
    //   //   this.error = false;
    //   // }
    //   // store.commit('setBmError', { bmError: this.error });
    //   store.commit('setBillmeterloading', { billmeterloading: false });
    // });
    apiService
      .get<any>(`/api/${labelToQuery}`)
      .then((resp:any) => {
        // console.log(resp[labelToQuery]);
        // console.log(dateYear);
        let temp = `${this.datesMonth[`0${resp[labelToQuery].data.data.mth[resp[labelToQuery].data.data.mth.length - 1]}`.slice(-2)]}`;
        this.to = `${temp}\'${`0${resp[labelToQuery].data.data.mth[resp[labelToQuery].data.data.mth.length - 1]}`.slice(1, 3)}`;
        temp = `${this.datesMonth[`0${resp[labelToQuery].data.data.mth[resp[labelToQuery].data.data.mth.length - 13]}`.slice(-2)]}`;
        this.from = `${temp}\'${`0${resp[labelToQuery].data.data.mth[resp[labelToQuery].data.data.mth.length - 13]}`.slice(1, 3)}`;
        let numMonths = 0;
        if (`0${resp[labelToQuery].data.data.mth[resp[labelToQuery].data.data.mth.length - 1]}`.slice(-2) === `0${(this.date.getMonth())}`.slice(-2)) {
          numMonths = this.date.getMonth() + 12;
        } else {
          numMonths = this.date.getMonth() + 11;
        }
        if (resp[labelToQuery].data.data.mth.length < numMonths && resp[labelToQuery].data.data.mth[0].slice(-2) !== '01') {
          if (numMonths < 12) {
            this.doesNotHaveData = true;
          }
          this.diffMonth = numMonths - resp[labelToQuery].data.data.mth.length;
          this.actualData = [];
          for (let i = 0; i < this.diffMonth; i = i + 1) {
            this.actualData[i] = NaN as Chart.ChartDataSets;
          }
          for (const val of resp[labelToQuery].data.data[this.selectedRightTabLabel === 'NAM' ? 'NorthAmerica' : this.selectedRightTabLabel === 'APJ' ?
          'Asia' : this.selectedRightTabLabel === 'EUR' ? 'Europe' : this.selectedRightTabLabel]) {
            this.actualData.push(val as Chart.ChartDataSets);
          }
      //     this.actualData.push(resp[labelToQuery].data.data[this.selectedRightTabLabel === 'NAM' ? 'NorthAmerica' : this.selectedRightTabLabel === 'APJ' ?
      // 'Asia' : this.selectedRightTabLabel === 'EUR' ? 'Europe' : this.selectedRightTabLabel]);
          if (rightLabel !== 'WW') {
            this.wwactualData = [];
            for (let i = 0; i < this.diffMonth; i = i + 1) {
              this.wwactualData[i] = NaN as Chart.ChartDataSets;
            }
            for (const val of resp[labelToQuery].data.data['WW']) {
              this.wwactualData.push(val as Chart.ChartDataSets);
            }
            // this.wwactualData.push(resp[labelToQuery].data.data['WW']);
          }
        } else {
          this.doesNotHaveData = false;
          this.actualData = resp[labelToQuery].data.data[this.selectedRightTabLabel === 'NAM' ? 'NorthAmerica' : this.selectedRightTabLabel === 'APJ' ?
      'Asia' : this.selectedRightTabLabel === 'EUR' ? 'Europe' : this.selectedRightTabLabel];
          if (rightLabel !== 'WW') {
            this.wwactualData = resp[labelToQuery].data.data['WW'];
          }
        }
        if (this.selectedLeftTabLabel === 'Spam Volume') {
          this.top4Origins = resp[labelToQuery].data.data['top4targetcountry'];
          this.top4OriginsData = resp[labelToQuery].data.data['top4targetpercent'];
          this.dataSetConc = [{ value: Number(resp[labelToQuery].data.data.emailpercent[0]), limit: 100 },
          { value: Number(resp[labelToQuery].data.data.emailpercent[1]), limit: 100 },
          { value: Number(resp[labelToQuery].data.data.emailpercent[2]), limit: 100 }];
          this.gaugeLabels = ['Spam', 'Phishing', 'Email Good'];
        } else if (this.selectedLeftTabLabel === 'Phishing Volume') {
          this.top4Origins = resp[labelToQuery].data.data['top4targetcountry'];
          this.top4OriginsData = resp[labelToQuery].data.data['top4targetpercent'];
          this.dataSetConc = [{ value: Number(resp[labelToQuery].data.data.targetpercent[0]), limit: 100 },
          { value: Number(resp[labelToQuery].data.data.targetpercent[1]), limit: 100 },
          { value: Number(resp[labelToQuery].data.data.targetpercent[2]), limit: 100 }];
          this.gaugeLabels = ['NAM', 'EUR', 'APJ'];
        } else if (rightLabel === 'WW' && this.selectedLeftTabLabel !== 'Web App Attacks') {
          this.top4Origins = resp[labelToQuery].data.data[`${rightLabel.toLowerCase()}oricountry`];
          this.top4OriginsData = resp[labelToQuery].data.data[`${rightLabel.toLowerCase()}oripercent`];
        } else {
          this.top4Origins = resp[labelToQuery].data.data[`${rightLabel.toLowerCase()}country`];
          this.top4OriginsData = resp[labelToQuery].data.data[`${rightLabel.toLowerCase()}percent`];
        }
        if (this.tabId !== 3 && this.tabId !== 4 && labelToQuery !== 'EncryptedTraffic') {
          if (labelToQuery === 'WebAppAttacks' && this.selectedRightTabLabel === 'NAM') {
            this.countryDataSet =
            [{ countryName: (this.top4Origins[0] === 'Czechia' ? 'Czech Republic' : (this.top4Origins[0] === 'South Korea' ? 'Republic of' :
             this.top4Origins[0])), countryId: (this.countryMap[this.top4Origins[0]
             === 'Czechia' ? 'Czech Republic' : (this.top4Origins[0] === 'South Korea' ? 'Republic of Korea' : this.top4Origins[0])]), attackPercent:
              Number(this.top4OriginsData[0]) },
            { countryName: (this.top4Origins[1] === 'Czechia' ? 'Czech Republic' : (this.top4Origins[1] === 'South Korea' ? 'Republic of Korea' :
             this.top4Origins[1])), countryId: (this.countryMap[this.top4Origins[1]
              === 'Czechia' ? 'Czech Republic' : (this.top4Origins[1] === 'South Korea' ? 'Republic of Korea' : this.top4Origins[1])]), attackPercent:
               Number(this.top4OriginsData[1]) },
            { countryName: (this.top4Origins[2] === 'Czechia' ? 'Czech Republic' : (this.top4Origins[2] === 'South Korea' ? 'Republic of Korea' :
             this.top4Origins[2])), countryId: (this.countryMap[this.top4Origins[2]
              === 'Czechia' ? 'Czech Republic' : (this.top4Origins[2] === 'South Korea' ? 'Republic of Korea' : this.top4Origins[2])]), attackPercent:
               Number(this.top4OriginsData[2]) }];
          } else {
            this.countryDataSet =
            [{ countryName: (this.top4Origins[0] === 'Czechia' ? 'Czech Republic' : (this.top4Origins[0] === 'South Korea' ? 'Republic of Korea' :
             this.top4Origins[0])), countryId: (this.countryMap[this.top4Origins[0]
             === 'Czechia' ? 'Czech Republic' : (this.top4Origins[0] === 'South Korea' ? 'Republic of Korea' : this.top4Origins[0])]),
              attackPercent: Number(this.top4OriginsData[0]) },
            { countryName: (this.top4Origins[1] === 'Czechia' ? 'Czech Republic' : (this.top4Origins[1] === 'South Korea' ? 'Republic of Korea' :
             this.top4Origins[1])), countryId: (this.countryMap[this.top4Origins[1]
             === 'Czechia' ? 'Czech Republic' : (this.top4Origins[1] === 'South Korea' ? 'Republic of Korea' : this.top4Origins[1])]),
              attackPercent: Number(this.top4OriginsData[1]) },
            { countryName: (this.top4Origins[2] === 'Czechia' ? 'Czech Republic' : (this.top4Origins[2] === 'South Korea' ? 'Republic of Korea' :
             this.top4Origins[2])), countryId: (this.countryMap[this.top4Origins[2]
             === 'Czechia' ? 'Czech Republic' : (this.top4Origins[2] === 'South Korea' ? 'Republic of Korea' : this.top4Origins[2])]),
              attackPercent: Number(this.top4OriginsData[2]) },
            { countryName: (this.top4Origins[3] === 'Czechia' ? 'Czech Republic' : (this.top4Origins[3] === 'South Korea' ? 'Republic of Korea' :
             this.top4Origins[3])), countryId: (this.countryMap[this.top4Origins[3]
             === 'Czechia' ? 'Czech Republic' : (this.top4Origins[3] === 'South Korea' ? 'Republic of Korea' : this.top4Origins[3])]),
              attackPercent: Number(this.top4OriginsData[3]) },
            { countryName: 'Others', country: 0, attackPercent: Number(this.top4OriginsData[4]) }];
          }
        }
        // this.processThreatData();
        this.loading = false;
        this.getData();
      });

    if (labelToQuery === 'https') {
      apiService
      .get<any>('/api/EncryptedTraffic')
      // .then(response => response.json() as Promise<TypeOfThreats[]>)
      .then((resp:any) => {
        // console.log(resp['EncryptedTraffic']);
        this.actualData1 = resp['EncryptedTraffic'].data.data['httpspercent'];
        this.label = 'percentage';
        this.dataPrev = [];
        this.dataYear = [];
        this.convertAll = 'percentage';
        for (let i = 0; i < 12; i = i + 1) {
          this.dataPrev.push(this.actualData1[i]);
        }
        for (let i = 12; i < this.actualData1.length; i = i + 1) {
          this.dataYear.push(this.actualData1[i]);
        }
        this.dataSet1 = [{ data: this.convertData(this.dataPrev, 0),
          label: this.convertAll, backgroundColor: 'transparent', borderColor: this.barColorPalette[0],
          spanGaps: true },
        { data: this.convertData(this.dataYear, 1),
          label: this.convertAll, backgroundColor: 'transparent', borderColor: this.barColorPalette[1],
          spanGaps: true }];
        const temp = [];
        for (const f of this.dataSet1) {
          this.convertToTypes(f);
        }
        temp.push(Number(this.dataPrev[this.dataYear.length - 1]));
        temp.push(Number(this.dataYear[this.dataYear.length - 1]));
        this.gauge = temp;
        this.loading = false;
        this.getData();
      });
    }
  }

  changeToWWValues(index: boolean) {
    const apiService = new ApiService('');
    apiService
    .get<any>('/api/WWPercent')
    // .then(response => response.json() as Promise<TypeOfThreats[]>)
    .then((resp:any) => {
      let threatType = '';
      for (let i = 0; i < resp.WWPercentVolume.data.data.threattype.length; i = i + 1) {
        if (resp.WWPercentVolume.data.data.threattype[i] === 'Non-Standard Ports') {
          threatType = 'Malware on non-std ports';
        } else if (resp.WWPercentVolume.data.data.threattype[i] === 'IoT') {
          threatType = 'IoT Malware';
        } else {
          threatType = resp.WWPercentVolume.data.data.threattype[i];
        }
        if (index && this.threatTypes[threatType] !== this.selectedVerticalTabId) {
          this.leftPercentages[this.threatTypes[threatType]] =
           resp.WWPercentVolume.data.data.percentage[i] === 'N/A'
           ? 'N/A' : Number(resp.WWPercentVolume.data.data.percentage[i]);
          this.rotateTabMappings[this.threatTypes[threatType]] = Number(resp.WWPercentVolume.data.data.percentage[i]) > 0 ?
           0 : 180;
        }
      }
    });
  }

  mounted() {
    this.changeToWWValues(false);
    this.processApi();
    // fetch('../../../../static/data/document.json')
    //   .then(response => response.json() as Promise<TypeOfThreats[]>)
    //   .then((data) => {
    //     if (data !== undefined) {
    //       this.threats = data;
    //       this.getData();
    //     }
    //   });
  }
}
